import TextField, { TextFieldProps } from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { PropsWithChildren, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import classes from './PasswordField.module.css';
import { useTranslation } from 'react-i18next';

export const PasswordField: React.FC<PropsWithChildren<Omit<TextFieldProps, 'type'>>> = ({ children, ...props }) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            label={t('common.form.password')}
            name='password'
            placeholder='••••••'
            id='password'
            autoComplete='new-password'
            variant='outlined'
            // all props above are allowed to be overridden
            {...props}
            type={showPassword ? 'text' : 'password'}
            slotProps={{
                ...props.slotProps,
                input: {
                    endAdornment: (
                        <InputAdornment position='end'>
                            {' '}
                            {showPassword ? (
                                <Visibility className={classes?.visibility} fontSize='small' onClick={() => setShowPassword(false)} />
                            ) : (
                                <VisibilityOff className={classes?.visibility} fontSize='small' onClick={() => setShowPassword(true)} />
                            )}
                        </InputAdornment>
                    ),
                },
            }}
        >
            {children}
        </TextField>
    );
};

export default PasswordField;
